import React from "react";

import useScrollTrigger, {
  UseScrollTriggerOptions,
} from "@mui/material/useScrollTrigger/useScrollTrigger";

/**
 * Use to alter the elevation of a component as the window is scrolled.
 * The `elevated` prop must be consumed in the child component.
 * See documentation for useScrollTrigger
 * https://mui.com/material-ui/react-app-bar/#usescrolltrigger-options-trigger
 */

interface ElevationScrollProps {
  children: React.ReactElement;
  scrollTriggerOption?: UseScrollTriggerOptions;
}

const ElevationScroll = ({
  children,
  scrollTriggerOption,
}: ElevationScrollProps) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    ...scrollTriggerOption,
  });

  return React.cloneElement(children, {
    elevated: trigger,
  });
};

export default ElevationScroll;
